import React from 'react';
import PerksList from 'ui/PerksList/PerksList';
import Raw from 'ui/Raw/Raw';

const DepartmentVideos = ({title, body, imageUrl, videos}) => (
    <div className="DepartmentVideos">
        <img
            src={imageUrl}
            alt=""
            className="img-responsive department-banner"
        />
        <h2>{title}</h2>
        <Raw content={body} />
        {videos && <PerksList perks={videos} />}
    </div>
);

export default DepartmentVideos;
